import { csvStringify, str } from './portabilityBasics';
import { stripPasskeys } from './bitwardenImport';

/* ─────────────────────────────── Exporters ─────────────────────────────── */

export function exportApibooJson(items, exportedAt = new Date().toISOString()) {
  const out = {
    version: 1,
    exportedAt,
    items: (Array.isArray(items) ? items : []).map((it) => ({
      type: it.type,
      name: str(it.name),
      data: stripPasskeys(it.data),
      favorite: !!it.favorite,
    })),
  };
  return JSON.stringify(out, null, 2);
}

/** Render a non-password item's data as readable text for the notes/extra column. */
export function itemToNotesText(item) {
  const d = (item && item.data) || {};
  switch (item.type) {
    case 'note':
      return str(d.body);
    case 'custom': {
      const lines = (Array.isArray(d.fields) ? d.fields : []).map(
        (f) => `${str(f.k)}: ${str(f.v)}`
      );
      if (str(d.notes)) lines.push(str(d.notes));
      return lines.join('\n');
    }
    case 'authHeader': {
      const lines = [];
      if (str(d.headerName)) lines.push(`${str(d.headerName)}: ${str(d.headerValue)}`);
      if (str(d.sourceEnv)) lines.push(`Environment: ${str(d.sourceEnv)}`);
      if (str(d.notes)) lines.push(str(d.notes));
      return lines.join('\n');
    }
    case 'dbConnection': {
      const lines = [];
      const add = (label, v) => {
        if (str(v) !== '') lines.push(`${label}: ${str(v)}`);
      };
      add('Engine', d.engine);
      add('Host', d.host);
      add('Port', d.port);
      add('Database', d.database);
      add('Username', d.username);
      add('Password', d.password);
      if (d.ssl) lines.push('SSL: true');
      if (str(d.notes)) lines.push(str(d.notes));
      return lines.join('\n');
    }
    case 'sftp': {
      const lines = [];
      const add = (label, v) => {
        if (str(v) !== '') lines.push(`${label}: ${str(v)}`);
      };
      add('Protocol', d.protocol);
      add('Host', d.host);
      add('Port', d.port);
      add('Username', d.username);
      add('Auth method', d.authMethod);
      add('Password', d.password);
      add('Private key', d.privateKey);
      add('Passphrase', d.passphrase);
      add('Initial path', d.initialPath);
      if (str(d.notes)) lines.push(str(d.notes));
      return lines.join('\n');
    }
    default:
      return str(d.notes);
  }
}

export function exportBitwardenCsv(items) {
  const header = [
    'folder',
    'favorite',
    'type',
    'name',
    'notes',
    'fields',
    'reprompt',
    'login_uri',
    'login_username',
    'login_password',
    'login_totp',
  ];
  const rows = [header];
  for (const it of Array.isArray(items) ? items : []) {
    const fav = it.favorite ? '1' : '';
    if (it.type === 'password') {
      const d = it.data || {};
      rows.push([
        str(d.folder).trim(),
        fav,
        'login',
        str(it.name),
        str(d.notes),
        '',
        '',
        str(d.url),
        str(d.username),
        str(d.password),
        str(d.totp),
      ]);
    } else {
      // note/custom/sftp/authHeader → Bitwarden "note" with data folded in.
      rows.push([
        str((it.data || {}).folder).trim(),
        fav,
        'note',
        str(it.name),
        itemToNotesText(it),
        '',
        '',
        '',
        '',
        '',
        '',
      ]);
    }
  }
  return csvStringify(rows);
}

export function exportLastpassCsv(items) {
  const header = ['url', 'username', 'password', 'totp', 'extra', 'name', 'grouping', 'fav'];
  const rows = [header];
  for (const it of Array.isArray(items) ? items : []) {
    const fav = it.favorite ? '1' : '';
    if (it.type === 'password') {
      const d = it.data || {};
      rows.push([
        str(d.url),
        str(d.username),
        str(d.password),
        str(d.totp),
        str(d.notes),
        str(it.name),
        str(d.folder).trim(),
        fav,
      ]);
    } else {
      // note/custom/sftp/authHeader → LastPass secure note (url == http://sn).
      rows.push([
        'http://sn',
        '',
        '',
        '',
        itemToNotesText(it),
        str(it.name),
        str((it.data || {}).folder).trim(),
        fav,
      ]);
    }
  }
  return csvStringify(rows);
}
